import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { DeliveryPreview } from "@/pages/DeliveryEditor";
import { Mail, X } from "lucide-react";

export default function PublicDelivery({ byPath = false }) {
  const params = useParams();
  const [search] = useSearchParams();
  const key = byPath ? params.customPath : params.slug;
  const apiPath = byPath ? `/public/p/${key}/delivery` : `/public/lm/${key}/delivery`;
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);
  // Show the "check your email" banner by default unless explicitly hidden via ?banner=0
  const [showBanner, setShowBanner] = useState(search.get("banner") !== "0");

  useEffect(() => {
    api.get(apiPath).then((r) => setData(r.data)).catch(() => setNotFound(true));
  }, [apiPath]);

  if (notFound) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="card-brutal !p-8 text-center max-w-md">
          <h1 className="font-display font-black text-3xl mb-2">404</h1>
          <p className="text-zinc-600">Content not found.</p>
        </div>
      </div>
    );
  }
  if (!data) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Loading…</div>;

  const accent = data.landing_config?.accent_color || "#FF4F00";

  return (
    <div className="min-h-screen bg-white" data-testid="public-delivery-page">
      {showBanner && (
        <div
          className="border-b-2 border-black"
          style={{ background: accent }}
          data-testid="check-email-banner"
        >
          <div className="max-w-3xl mx-auto px-6 py-4 flex items-center gap-3 text-white">
            <div className="w-9 h-9 bg-white border-2 border-black flex items-center justify-center flex-shrink-0">
              <Mail size={18} style={{ color: accent }} />
            </div>
            <div className="flex-1">
              <div className="font-display font-bold text-base md:text-lg leading-tight">
                Check your email — we just sent your content.
              </div>
              <div className="text-xs md:text-sm opacity-90 mt-0.5">
                In the meantime, your lead magnet is ready below ↓
              </div>
            </div>
            <button
              onClick={() => setShowBanner(false)}
              className="w-8 h-8 border-2 border-black bg-white flex items-center justify-center flex-shrink-0"
              aria-label="Dismiss"
              data-testid="dismiss-banner-btn"
            >
              <X size={14} style={{ color: accent }} />
            </button>
          </div>
        </div>
      )}
      <header className="border-b-2 border-black">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="font-display font-black tracking-tight">VIBELEAD</div>
          <div className="text-xs label-cap" style={{ color: accent }}>Your Resource</div>
        </div>
      </header>
      <DeliveryPreview cfg={data.delivery_config} />
      <footer className="border-t-2 border-black mt-12 py-6 text-center text-xs text-zinc-500">
        Delivered with VibeLead · <a href="/" className="font-bold underline">Build your own</a>
      </footer>
    </div>
  );
}
